import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Pushes a page_view event to GTM's dataLayer on every route change (SPA navigation)
export default function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "page_view",
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);

  return null;
}
